/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import type {
  Moderator,
  ModeratorForgotPasswordRequest,
  ModeratorLoginRequest,
  ModeratorResetPasswordRequest,
  ModeratorTwoFactorVerifyRequest,
  ModeratorsAuthForgotPasswordCreate200,
  ModeratorsAuthResetPasswordCreate200
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Email a 6-digit password reset code to an active moderator. Always returns the same 200 response, whether or not the email belongs to an active moderator. Use the code with `resetPassword`.
 * @summary Moderator forgot password (request code)
 */
export const moderatorsAuthForgotPasswordCreate = (
    moderatorForgotPasswordRequest: ModeratorForgotPasswordRequest,
 ) => {
      
      
      return customInstance<ModeratorsAuthForgotPasswordCreate200>(
      {url: `/api/v1/moderators/auth/forgotPassword/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorForgotPasswordRequest
    },
      );
    }
  


export const getModeratorsAuthForgotPasswordCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsAuthForgotPasswordCreate>>, TError,{data: ModeratorForgotPasswordRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsAuthForgotPasswordCreate>>, TError,{data: ModeratorForgotPasswordRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsAuthForgotPasswordCreate>>, {data: ModeratorForgotPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsAuthForgotPasswordCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsAuthForgotPasswordCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsAuthForgotPasswordCreate>>>
    export type ModeratorsAuthForgotPasswordCreateMutationBody = ModeratorForgotPasswordRequest
    export type ModeratorsAuthForgotPasswordCreateMutationError = void

    /**
 * @summary Moderator forgot password (request code)
 */
export const useModeratorsAuthForgotPasswordCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsAuthForgotPasswordCreate>>, TError,{data: ModeratorForgotPasswordRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsAuthForgotPasswordCreate>>,
        TError,
        {data: ModeratorForgotPasswordRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsAuthForgotPasswordCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Login with email and password. Sets session cookie for subsequent requests.
 * @summary Moderator login
 */
export const moderatorsAuthLoginCreate = (
    moderatorLoginRequest: ModeratorLoginRequest,
 ) => {
      
      
      return customInstance<Moderator>(
      {url: `/api/v1/moderators/auth/login/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorLoginRequest
    },
      );
    }
  


export const getModeratorsAuthLoginCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsAuthLoginCreate>>, TError,{data: ModeratorLoginRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsAuthLoginCreate>>, TError,{data: ModeratorLoginRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsAuthLoginCreate>>, {data: ModeratorLoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsAuthLoginCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsAuthLoginCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsAuthLoginCreate>>>
    export type ModeratorsAuthLoginCreateMutationBody = ModeratorLoginRequest
    export type ModeratorsAuthLoginCreateMutationError = void

    /**
 * @summary Moderator login
 */
export const useModeratorsAuthLoginCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsAuthLoginCreate>>, TError,{data: ModeratorLoginRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsAuthLoginCreate>>,
        TError,
        {data: ModeratorLoginRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsAuthLoginCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Logout and clear session.
 * @summary Moderator logout
 */
export const moderatorsAuthLogoutCreate = (
    
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/auth/logout/`, method: 'POST'
    },
      );
    }
  


export const getModeratorsAuthLogoutCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsAuthLogoutCreate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsAuthLogoutCreate>>, TError,void, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsAuthLogoutCreate>>, void> = () => {
          

          return  moderatorsAuthLogoutCreate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsAuthLogoutCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsAuthLogoutCreate>>>
    
    export type ModeratorsAuthLogoutCreateMutationError = unknown

    /**
 * @summary Moderator logout
 */
export const useModeratorsAuthLogoutCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsAuthLogoutCreate>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsAuthLogoutCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getModeratorsAuthLogoutCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Set a new password using the email and the 6-digit code sent by `forgotPassword`. Ends all of the moderator's existing sessions.
 * @summary Moderator reset password
 */
export const moderatorsAuthResetPasswordCreate = (
    moderatorResetPasswordRequest: ModeratorResetPasswordRequest,
 ) => {
      
      
      return customInstance<ModeratorsAuthResetPasswordCreate200>(
      {url: `/api/v1/moderators/auth/resetPassword/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorResetPasswordRequest
    },
      );
    }
  


export const getModeratorsAuthResetPasswordCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsAuthResetPasswordCreate>>, TError,{data: ModeratorResetPasswordRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsAuthResetPasswordCreate>>, TError,{data: ModeratorResetPasswordRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsAuthResetPasswordCreate>>, {data: ModeratorResetPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsAuthResetPasswordCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsAuthResetPasswordCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsAuthResetPasswordCreate>>>
    export type ModeratorsAuthResetPasswordCreateMutationBody = ModeratorResetPasswordRequest
    export type ModeratorsAuthResetPasswordCreateMutationError = void

    /**
 * @summary Moderator reset password
 */
export const useModeratorsAuthResetPasswordCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsAuthResetPasswordCreate>>, TError,{data: ModeratorResetPasswordRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsAuthResetPasswordCreate>>,
        TError,
        {data: ModeratorResetPasswordRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsAuthResetPasswordCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Second leg of moderator login. Submit `challengeToken` from `/login` together with either a TOTP code or a recovery code.
 * @summary Moderator 2FA verify
 */
export const moderatorsAuthVerifyTwoFactorCreate = (
    moderatorTwoFactorVerifyRequest: ModeratorTwoFactorVerifyRequest,
 ) => {
      
      
      return customInstance<Moderator>(
      {url: `/api/v1/moderators/auth/verifyTwoFactor/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorTwoFactorVerifyRequest
    },
      );
    }
  


export const getModeratorsAuthVerifyTwoFactorCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsAuthVerifyTwoFactorCreate>>, TError,{data: ModeratorTwoFactorVerifyRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsAuthVerifyTwoFactorCreate>>, TError,{data: ModeratorTwoFactorVerifyRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsAuthVerifyTwoFactorCreate>>, {data: ModeratorTwoFactorVerifyRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsAuthVerifyTwoFactorCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsAuthVerifyTwoFactorCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsAuthVerifyTwoFactorCreate>>>
    export type ModeratorsAuthVerifyTwoFactorCreateMutationBody = ModeratorTwoFactorVerifyRequest
    export type ModeratorsAuthVerifyTwoFactorCreateMutationError = void

    /**
 * @summary Moderator 2FA verify
 */
export const useModeratorsAuthVerifyTwoFactorCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsAuthVerifyTwoFactorCreate>>, TError,{data: ModeratorTwoFactorVerifyRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsAuthVerifyTwoFactorCreate>>,
        TError,
        {data: ModeratorTwoFactorVerifyRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsAuthVerifyTwoFactorCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    